import { Grid, Paper } from '@material-ui/core'
import { Fragment } from 'react'
import { Step4Props } from '../../../../../types/steps'
import ApartmentConfirmationForm from '../../../Forms/ApartmentConfirmationForm'
import { getApartmentConfirmationInitialValues } from '../../../Forms/values/apartmentInitialValues'

const Step4Confirmation = ({
  baseFormStepProps: {
    currentStep,
    doStepBack,
    apartment,
    isAdmin,
    isConfirmed,
    isMobile
  },
  classes,
  apartmentConfirmation
}: Step4Props) => (
  <Fragment>
    {apartment?.information && currentStep >= 9 && currentStep < 11 && (
      <Grid container direction='row' justify='space-evenly'>
        <Grid item sm={12} md={12}>
          <Paper className={classes.formPaper}>
            <ApartmentConfirmationForm
              currentStep={currentStep}
              doStepBack={doStepBack}
              initialValues={
                apartment.confirmation
                  ? getApartmentConfirmationInitialValues(
                      apartment.confirmation
                    )
                  : { showingType: 'openHouse' }
              }
              vuokraoviCollateral={(apartment.confirmation as any)?.vuokraoviCollateral}
              contactInfoPublicOnPlatforms={(apartment.confirmation as any)?.contactInfoPublicOnPlatforms}
              updateApartmentConfirmation={apartmentConfirmation}
              isDisabled={isAdmin ? false : isConfirmed}
              createdAt={apartment.createdAt}
              classes={classes}
              isMobile={isMobile}
            />
          </Paper>
        </Grid>
      </Grid>
    )}
  </Fragment>
)

export default Step4Confirmation
